export default {"src":"/_next/static/media/RVMD.a6430713.svg","height":18,"width":18};